/**
 * List of nature noise icons
 * To be used as keys for noise icon dictionary
 */
const noise_icon = [
    'Bird', 'Rain', 'Fire', 'Creek', 'Wave'
];

export default noise_icon;